import React from "react";
import cn from "classnames";
import styles from "./style.scss";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}

export const OutlineButton: React.FC<Props> = ({
  children,
  className,
  ...props
}) => {
  return (
    <button {...props} className={cn(styles.button, className)}>
      {children}
    </button>
  );
};
